import { useState } from "react";
import { toast } from "sonner";
import { Field, Card, SaveButton, GhostButton, inputCls, areaCls } from "../ui";
import { adminFetch } from "../adminApi";

const GROUPS = [
  { title: "Hero (Startbildschirm)", fields: [["hero_overline", "Überzeile"], ["hero_title_1", "Überschrift Zeile 1"], ["hero_title_2", "Überschrift Zeile 2"], ["hero_sub", "Beschreibung"]] },
  { title: "Leistungen", fields: [["services_eyebrow", "Überzeile"], ["services_title", "Überschrift"], ["services_sub", "Beschreibung"], ["custom_package_title", "Titel: Individuelle Pflegepakete"], ["custom_package_desc", "Beschreibung Kartenpaket"], ["custom_package_tags", "Tags (mit Komma trennen)"]] },
  { title: "Preisrechner", fields: [["calc_eyebrow", "Überzeile"], ["calc_title", "Überschrift"], ["calc_sub", "Beschreibung"]] },
  { title: "Ablauf", fields: [["process_eyebrow", "Überzeile"], ["process_title", "Überschrift"], ["process_sub", "Beschreibung"]] },
  { title: "Vorher / Nachher", fields: [["gallery_eyebrow", "Überzeile"], ["gallery_title", "Überschrift"], ["gallery_sub", "Beschreibung"]] },
  { title: "Bewertungen", fields: [["reviews_eyebrow", "Überzeile"], ["reviews_title", "Überschrift"], ["reviews_sub", "Beschreibung"]] },
  { title: "FAQ", fields: [["faq_eyebrow", "Überzeile"], ["faq_title", "Überschrift"], ["faq_sub", "Beschreibung"]] },
  { title: "Terminbuchung", fields: [["booking_eyebrow", "Überzeile"], ["booking_title", "Überschrift"], ["booking_sub", "Beschreibung"]] },
];

export default function TextsTab({ content, reload }) {
  const [draft, setDraft] = useState(() => ({ ...(content.texts || {}) }));
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await adminFetch("/admin/content/texts", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(draft),
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
      await reload();
      toast.success("Texte gespeichert – live auf der Website.");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <p className="text-sm text-zinc-400 leading-relaxed">
        Alle Überschriften und Beschreibungen der Website. Leere Felder zeigen automatisch den
        Standardtext.
      </p>

      {GROUPS.map((g) => (
        <Card key={g.title} title={g.title}>
          {g.fields.map(([key, label]) => (
            <Field key={key} label={label}>
              {key.endsWith("_sub") ? (
                <textarea className={areaCls} value={draft[key] || ""} onChange={(e) => setDraft((d) => ({ ...d, [key]: e.target.value }))} maxLength={3000} />
              ) : (
                <input className={inputCls} value={draft[key] || ""} onChange={(e) => setDraft((d) => ({ ...d, [key]: e.target.value }))} maxLength={200} />
              )}
            </Field>
          ))}
        </Card>
      ))}

      <div className="sticky bottom-4 flex items-center gap-3 rounded-2xl border border-[#27272A] bg-[#0C0C0E]/95 p-4 backdrop-blur">
        <SaveButton onClick={save} saving={saving} saved={saved} testid="admin-save-texts" />
        <GhostButton onClick={() => setDraft({ ...(content.texts || {}) })} testid="admin-reset-texts">
          Verwerfen
        </GhostButton>
      </div>
    </div>
  );
}
